import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralManager\GetUsageController::__invoke
* @see app/Http/Controllers/FuneralManager/GetUsageController.php
* @route '/api/funeral-manager/usage'
*/
const GetUsageController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetUsageController.url(options),
    method: 'get',
})

GetUsageController.definition = {
    methods: ["get","head"],
    url: '/api/funeral-manager/usage',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralManager\GetUsageController::__invoke
* @see app/Http/Controllers/FuneralManager/GetUsageController.php
* @route '/api/funeral-manager/usage'
*/
GetUsageController.url = (options?: RouteQueryOptions) => {
    return GetUsageController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralManager\GetUsageController::__invoke
* @see app/Http/Controllers/FuneralManager/GetUsageController.php
* @route '/api/funeral-manager/usage'
*/
GetUsageController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetUsageController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralManager\GetUsageController::__invoke
* @see app/Http/Controllers/FuneralManager/GetUsageController.php
* @route '/api/funeral-manager/usage'
*/
GetUsageController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetUsageController.url(options),
    method: 'head',
})

export default GetUsageController